<mat-toolbar>
  <span translate>ATTRIBUTELOOKUP</span>
  <span class="toolbar-spacer"></span>
  <!-- <button mat-raised-button color="accent" [matMenuTriggerFor]="exportMenu" [disabled]="!devices.length">
  Export
</button>
<mat-menu #exportMenu="matMenu">
  <button mat-menu-item (click)="exporter.exportTable('csv')">Export as CSV</button>
  <button mat-menu-item (click)="exporter.exportTable('xls')">Export as XLS</button>
</mat-menu> -->
<button type="button" mat-raised-button (click)="resetFilters()" class="ms-2">
  Reset
</button>
<button type="button" mat-raised-button color="primary" (click)="fetchItems()" class="ms-2">
  Filter
</button>
</mat-toolbar>

<div class="row mt-3">
  <div class="col-md-3">
    <mat-form-field class="w-100">
      <mat-label translate>TYPE</mat-label>
      <mat-select [(ngModel)]="filters.type">
        @for (type of types; track type) {
          <mat-option [value]="type.id">{{type.name}}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <div class="col-md-3">
    <mat-form-field class="w-100">
      <mat-label translate>NETWORKS</mat-label>
      <mat-select [(ngModel)]="filters.network">
        @for (network of networks; track network) {
          <mat-option [value]="network.id">{{network.name}}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <div class="col-md-3">
    <app-select-search label="Attribute" [list]="attributes" [model]="filters.attribute" (modelChanged)="filters.attribute = $event;" [isMultiple]="true"></app-select-search>
  </div>
</div>

<div [hidden]="!devices.length">
  <!-- <table mat-table matSort [dataSource]="dataSource" class="w-100" matTableExporter #exporter="matTableExporter" > -->
  <table mat-table matSort [dataSource]="dataSource" class="w-100">
    @for (col of columnsToDisplay; track col) {
      <ng-container matColumnDef="{{ col }}" >
        <th mat-header-cell *matHeaderCellDef mat-sort-header translate class="text-capitalize">{{ col }}</th>
        <td mat-cell *matCellDef="let element" class="text-capitalize">
          @switch (col) {
            @case ('type') {
              <div>{{element.type ? element.type.name : '-' }}</div>
            }
            @case ('company') {
              <div>{{element.company ? element.company.name : '-' }}</div>
            }
            @case ('site') {
              <div>{{element.site ? element.site.name : '-' }}</div>
            }
            @case ('action') {
              <div class="text-end">
                @if (element.company) {
                  <a matTooltip="View in tree" mat-icon-button color="primary" (click)="$event.stopPropagation();" target="_blank" [routerLink]="['/networks', element.company.id]"><mat-icon>account_tree</mat-icon></a>
                }
                <a matTooltip="Settings" mat-icon-button color="primary" [routerLink]="['/device', element.id]" target="_blank"><mat-icon>settings</mat-icon></a>
              </div>
            }
            @default {
              <div>{{element[col]}}</div>
            }
          }
        </td>
      </ng-container>
    }
    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr mat-row *matRowDef="let element; columns: columnsToDisplay;"
      class="example-element-row">
    </tr>
  </table>
  <mat-paginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>
</div>
@if (devices.length === 0) {
  <div class="w-100 p-3 text-center text-muted" translate>NO_DEVICE_FOUND</div>
}
